<template>
    <div class="collection-host">
        <Message v-if="readFailure" severity="error" :closable="false" class="collection-host__error">
            {{ readFailure }}
        </Message>

        <AdminCollectionLayout
            class="collection-host__layout"
            :config="config"
            controlled
            search-ui="bar"
            :simplify-when-small="false"
            @update:query="onQuery"
        >
            <template #instance="{ record, draft, isNew, setField, fieldDefinitions, fieldMeta }">
                <MachineInstanceBody
                    :record="record"
                    :draft="draft"
                    :is-new="isNew"
                    :set-field="setField"
                    :store="store"
                    :field-definitions="fieldDefinitions"
                    :field-meta="fieldMeta"
                    :write-failure="writeFailure"
                    @issued="(answer) => (issued = answer)"
                />
            </template>
        </AdminCollectionLayout>

        <Paginator
            v-if="store.totalCount > pageSize"
            class="collection-host__paginator"
            :rows="pageSize"
            :total-records="store.totalCount"
            :first="(page - 1) * pageSize"
            @page="(event) => goToPage(event.page + 1)"
        />

        <!-- The one place a client secret is ever shown. Making a Machine and rotating a
             credential both land here; "I have copied it" is the only way out, and it clears
             the answer so nothing can show it again. -->
        <IssuedSecretDialog :issued="issued" @acknowledged="issued = null" />
    </div>
</template>

<script setup>
import { machinesStore } from '@hds/identity-client-sdk'
import Message from 'primevue/message'
import Paginator from 'primevue/paginator'

import AdminCollectionLayout from '@/admin-collection-layout/components/AdminCollectionLayout.vue'
import IssuedSecretDialog from '@/components/identity/IssuedSecretDialog.vue'
import MachineInstanceBody from '@/components/identity/MachineInstanceBody.vue'
import { useIdentityCollection } from '@/composables/useIdentityCollection.js'
import { MACHINES } from '@/lib/identityCollections.js'

// Machines, the way the five administration nouns are shown, over the identity server's list
// of programs. New opens the panel on a name; saving makes the Machine and shows its secret once.
const props = defineProps({
    title: { type: String, required: true }
})

const store = machinesStore()
const { config, onQuery, readFailure, writeFailure, issued, page, pageSize, goToPage } = useIdentityCollection({
    store,
    descriptor: MACHINES,
    title: props.title,
    storageKey: 'machines'
})
</script>

<style scoped>
.collection-host {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
}

.collection-host__error {
    flex: 0 0 auto;
    margin: 16px 16px 0;
}

.collection-host__layout {
    flex: 1 1 auto;
    min-height: 0;
}

.collection-host__paginator {
    border-top: 1px solid var(--p-content-border-color);
    flex: 0 0 auto;
}
</style>
